module.exports = __webpack_public_path__ + "img/utility-bg.159b2b1a.webp";